import React from 'react';
import {reduxForm, reset, Field} from 'redux-form';
import { Link } from 'react-router-dom';
import {Input} from '../../ui/Input';
import {required} from 'redux-form-validators';
import Button from '../../../../components/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '../ui/Select';

import useStyles from './styles';
import { useTranslation } from 'react-i18next';

let AddCategoryForm = (props) => {
    const {
        load,
        language,
        languages,
        selectedTerminals,
        handleSubmit,
        handleChange,
        changeSelectOpen,
        changeSelectClose,
        selectedCities,
        changeCity, 
        cities,
    } = props;

    const classes = useStyles();
    const isOneCity = cities.length === 1;
    const isOneTerminal = selectedTerminals.length === 1;

    const brand = JSON.parse(localStorage.getItem("currentBrand"));
    const { t } = useTranslation();

    return (
        <form className={classes.formContainer}  autoComplete='off' onSubmit={handleSubmit}>
            <Link to={`/page/menu/products/${brand.id}`} className={classes.close}>
                <ArrowBackIcon className={classes.closeIcon} />
            </Link>
            <span className={classes.title}>{t('categories.addCategory')}</span>
            {languages.map(item => {
                let name = item.label.split(' ')[2];
                name = name.replace('ом', 'ий');
                name = name.charAt(0).toUpperCase() + name.slice(1);
                return (
                    <Field key={item.key} name={item.key}
                        component={Input} label={`${t('categories.name')} (${name})`} 
                        validate={item.key === language ? required({msg: t('modals.requiredField')}): null}
                    />
                )
            })}

            <div className={classes.adresses}>
                <FormControl component="fieldset" className={classes.formControl}>
                    {/* {!isOneCity && <FormLabel component="legend"><span style={{ color: 'black' }}>Выберите город из списка </span><span style={{ color: 'red' }}>*</span></FormLabel>}

                    {!isOneCity && <Select 
                        cities={cities}
                        changeSelectOpen={changeSelectOpen}
                        changeSelectClose={changeSelectClose}
                        selectedCities={selectedCities} 
                        changeCity={changeCity} />} */}

                    <FormGroup
                        className={classes.formControlLabel}
                    >
                        {!isOneTerminal && selectedTerminals && <FormLabel className={classes.checkTerminals} component="legend"><span style={{ color: 'black' }}>Отображать в заведении</span></FormLabel>}
                        {!isOneTerminal && selectedTerminals.map(item => 
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color={'primary'}  
                                        key={item.name} 
                                        checked={item.visible === "1"} 
                                        onChange={handleChange} 
                                        name={item.id} 
                                    />
                                }
                                label={item.name}
                            />    
                        )}
                    </FormGroup>
                </FormControl>
            </div>
            <Button 
                className={classes.button} 
                fontSize={22} 
                color={'#fff'} 
                load={load}
                // disabled={props.pristine || props.submitting || !selectedCities.length > 0}
                disabled={props.pristine || props.submitting}
                text={t('buttons.add')}
                handleClick={handleSubmit} />
        </form>
    )
}

const afterSubmit = (_, dispatch) =>
  dispatch(reset('addCategory'));

AddCategoryForm = reduxForm({form: 'addCategory', onSubmitSuccess: afterSubmit})(AddCategoryForm);

export default AddCategoryForm;
